import { render, staticRenderFns } from "./FormInputTagsComponent.vue?vue&type=template&id=64686f3d&scoped=true"
import script from "./FormInputTagsComponent.vue?vue&type=script&lang=js"
export * from "./FormInputTagsComponent.vue?vue&type=script&lang=js"
import style0 from "./FormInputTagsComponent.vue?vue&type=style&index=0&id=64686f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64686f3d",
  null
  
)

export default component.exports